import { ExamEventDetailsProvider } from '@exam-center/exam-event-management';
import { ExamEventScoreReportHeader } from '@exam-center/exam-event-score-report';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { Flex } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ExamEventScoreReportLayout() {
  const { examEventId, examCenterCode } = useParams(
    '/:examCenterCode/exam-events/:examEventId/score-report',
  );

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW,
        APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAMINEES.VIEW,
        APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW,
      ]}
      options={{ operator: 'OR' }}
    >
      <ExamEventDetailsProvider examEventId={examEventId} examCenterCode={examCenterCode}>
        <ExamEventScoreReportHeader examCenterCode={examCenterCode} />
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            p: theme.spacing(6),
            gap: theme.spacing(6),
            flex: 1,
          })}
        >
          <Outlet />
        </Flex>
      </ExamEventDetailsProvider>
    </PermissionGuard>
  );
}
